<template>
  <v-container>
    <v-layout
      wrap
      justify-space-around
      fill-height
      align-center
      v-on:mouseover="flags.updateImage = true"
      v-on:mouseleave="flags.updateImage = false"
    >
      <v-flex xs12>
        <v-layout row wrap justify-center>
          <v-flex xs12 sm6 xl4>
            <v-list v-if="notice" two-line>
              <div v-if="notice && notice.files && notice.files.length > 0">Documentos anexados</div>
              <template v-for="(item, index) in notice.files">
                <v-list-tile avatar :key="index">
                  <v-list-tile-avatar>
                    <v-icon>chrome_reader_mode</v-icon>
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title v-html="item.name"></v-list-tile-title>
                    <v-list-tile-sub-title
                      v-html="item.type+' '+(item.size/(1024*1024)).toFixed(2)+'Mb'"
                    ></v-list-tile-sub-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-btn icon ripple @click="erase(index)">
                      <v-icon color="grey lighten-1">clear</v-icon>
                    </v-btn>
                  </v-list-tile-action>
                </v-list-tile>
              </template>
            </v-list>

            <v-flex xs12 class="mt3"></v-flex>
                
            <!-- File picker -->
            <FileAttachment v-on:selected-file="onSelectedFile" center />
            <!-- File picker -->
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import alert from "../../Dialogs/Alert";
import FileAttachment from "../../Tools/FileAttachment";
export default {
  components: {
    alert,
    FileAttachment
  },
  props: ["notice","value"],
  data: () => ({
    flags: {
      updateImage: false
    },
    modals: {
      image: false,
      warning: false,
      size: false
    },
    noticeForm: {
      files: [],
    },
  }),
   watch: {
    value() {
      if (this.value == null || this.value == []) {
        this.noticeForm = {
          files: []
        };
      }
    }
  },
  methods: {
    onSelectedFile(file) {
      //old attach
      this.notice.files.push(file);
      this.value.push(file);
      //this.noticeForm.files.push(file);
    },
    erase(index) {
      this.notice.files.splice(index, 1);
      this.value.splice(index, 1);
    }
  }
};
</script>

<style>
</style>
